var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	4470: () => (loadStrictSingletonVersion("default", "@angular/platform-browser", false, [4,19,2,8], () => (__webpack_require__.e("node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f1").then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 436))))))),
	4819: () => (loadStrictSingletonVersion("default", "@angular/common/http", false, [4,19,2,8], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_http_mjs-_f9341").then(() => (() => (__webpack_require__(/*! @angular/common/http */ 6443))))))),
	4171: () => (loadStrictSingletonVersion("default", "@angular/core", false, [4,19,2,8], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs").then(() => (() => (__webpack_require__(/*! @angular/core */ 7580))))))),
	4673: () => (loadStrictSingletonVersion("default", "@angular/router", false, [4,19,2,8], () => (__webpack_require__.e("node_modules_angular_router_fesm2022_router_mjs-_5a220").then(() => (() => (__webpack_require__(/*! @angular/router */ 5072))))))),
	3270: () => (loadStrictSingletonVersion("default", "@ngx-translate/core", false, [1,18,0,0], () => (__webpack_require__.e("node_modules_ngx-translate_core_fesm2022_ngx-translate-core_mjs-_89912").then(() => (() => (__webpack_require__(/*! @ngx-translate/core */ 8503))))))),
	3854: () => (loadStrictSingletonVersion("default", "@timbro/timbro-access-styleguide", false, [4,0,15,11], () => (__webpack_require__.e("node_modules_timbro_timbro-access-styleguide_fesm2022_timbro-timbro-access-styleguide_mjs-_240e0").then(() => (() => (__webpack_require__(/*! @timbro/timbro-access-styleguide */ 333))))))),
	4866: () => (loadStrictSingletonVersion("default", "rxjs", false, [2,7,8,0], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_index_js-_1ecf0").then(() => (() => (__webpack_require__(/*! rxjs */ 845))))))),
	2901: () => (loadStrictSingletonVersion("default", "@angular/common", false, [4,19,2,8], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b4621").then(() => (() => (__webpack_require__(/*! @angular/common */ 316))))))),
	4616: () => (loadStrictSingletonVersion("default", "rxjs", false, [,[1,7,4,0],[1,6,5,3],1], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_index_js-_1ecf0").then(() => (() => (__webpack_require__(/*! rxjs */ 845))))))),
	2983: () => (loadStrictSingletonVersion("default", "@angular/forms", false, [4,19,2,8], () => (__webpack_require__.e("node_modules_angular_forms_fesm2022_forms_mjs-_0f7c1").then(() => (() => (__webpack_require__(/*! @angular/forms */ 4456))))))),
	2945: () => (loadStrictSingletonVersion("default", "rxjs", false, [0,7], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_index_js-_1ecf1").then(() => (() => (__webpack_require__(/*! rxjs */ 845))))))),
	6820: () => (loadStrictSingletonVersion("default", "@ngx-translate/core", false, [0,18,1,0], () => (__webpack_require__.e("node_modules_ngx-translate_core_fesm2022_ngx-translate-core_mjs-_89911").then(() => (() => (__webpack_require__(/*! @ngx-translate/core */ 8503))))))),
	6657: () => (loadStrictSingletonVersion("default", "@ngx-translate/http-loader", false, [1,18,0,0], () => (__webpack_require__.e("node_modules_ngx-translate_http-loader_fesm2022_ngx-translate-http-loader_mjs-_b6c21").then(() => (() => (__webpack_require__(/*! @ngx-translate/http-loader */ 2279)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"src_bootstrap_ts": [
		4470,
		4819,
		4171,
		4673,
		3270,
		3854,
		4866,
		2901,
		4616,
		2983
	],
	"node_modules_angular_common_fesm2022_http_mjs-_f9340": [
		4171,
		4616
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b4620": [
		4171,
		4616
	],
	"node_modules_angular_core_fesm2022_core_mjs": [
		4616
	],
	"node_modules_angular_forms_fesm2022_forms_mjs-_0f7c0": [
		2901,
		4171,
		4616
	],
	"node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f0": [
		2901,
		4171,
		4819
	],
	"node_modules_angular_router_fesm2022_router_mjs-_5a221": [
		2901,
		4171,
		4616,
		4470
	],
	"node_modules_ngx-translate_core_fesm2022_ngx-translate-core_mjs-_89910": [
		2901,
		2945,
		4171,
		4616
	],
	"node_modules_ngx-translate_http-loader_fesm2022_ngx-translate-http-loader_mjs-_b6c20": [
		4171,
		4819,
		4866,
		6820
	],
	"node_modules_timbro_timbro-access-styleguide_fesm2022_timbro-timbro-access-styleguide_mjs-_240e1": [
		4171,
		2901,
		2983,
		4866,
		3270,
		4616,
		4819,
		6657
	],
	"node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f1": [
		4819
	],
	"node_modules_angular_common_fesm2022_http_mjs-_f9341": [
		4616
	],
	"node_modules_ngx-translate_core_fesm2022_ngx-translate-core_mjs-_89912": [
		2945
	],
	"node_modules_timbro_timbro-access-styleguide_fesm2022_timbro-timbro-access-styleguide_mjs-_240e0": [
		6657
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b4621": [
		4616
	],
	"node_modules_ngx-translate_core_fesm2022_ngx-translate-core_mjs-_89911": [
		2901,
		2945,
		4616
	],
	"node_modules_ngx-translate_http-loader_fesm2022_ngx-translate-http-loader_mjs-_b6c21": [
		6820
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}